// extracted by mini-css-extract-plugin
module.exports = {"root":"PendingPaymentAlert_root__Y2Ayz","buttons":"PendingPaymentAlert_buttons__3Dhzp"};